<template>
  <div class="pay-qr-page">
    <van-nav-bar title="扫码支付" left-arrow @click-left="$router.back()" fixed placeholder />

    <div class="content">
      <div class="tip">请保存二维码，用支付宝扫码支付</div>
      <div class="order-code" v-if="orderCode">订单号：{{ orderCode }}</div>

      <div class="qr-wrap">
        <img v-if="qrImg" :src="qrImg" alt="支付二维码" class="qr-img" />
        <van-loading v-else type="spinner" />
      </div>
      <p class="qr-hint">也可长按图片保存到相册</p>

      <van-button plain block round class="save-btn" @click="saveQrImage">
        保存图片
      </van-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PayQr',
  data() {
    return {
      orderCode: '',
      scheme: '',
      universal: '',
      tradeNo: '',
      qrImg: '',
    };
  },
  created() {
    this.orderCode = this.$route.query.orderCode || '';
    try {
      const raw = sessionStorage.getItem('mx_alipay_pay');
      if (raw) {
        const saved = JSON.parse(raw);
        if (saved && (!this.orderCode || saved.orderCode === this.orderCode)) {
          this.orderCode = this.orderCode || saved.orderCode || '';
          this.scheme = saved.scheme || '';
          this.universal = saved.universal || '';
          this.tradeNo = saved.tradeNo || '';
        }
      }
    } catch (e) { /* ignore */ }
    this.buildQr();
  },
  methods: {
    buildQr() {
      const payload = this.universal || this.scheme;
      if (!payload) {
        this.$toast.fail('二维码未生成');
        return;
      }
      this.qrImg =
        'https://api.qrserver.com/v1/create-qr-code/?size=240x240&margin=8&data=' +
        encodeURIComponent(payload);
    },
    async saveQrImage() {
      if (!this.qrImg) {
        this.$toast.fail('二维码未生成');
        return;
      }
      const ua = navigator.userAgent || '';
      if (/MicroMessenger/i.test(ua)) {
        this.$toast('请长按二维码保存到相册');
        return;
      }
      const filename = `pay-qr${this.orderCode ? '-' + this.orderCode : ''}.png`;
      try {
        const res = await fetch(this.qrImg, { mode: 'cors' });
        if (!res.ok) throw new Error('fetch failed');
        const blob = await res.blob();
        const objectUrl = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = objectUrl;
        a.download = filename;
        a.rel = 'noopener';
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
        this.$toast.success('已保存，若未生效请长按二维码保存');
      } catch (e) {
        this.$toast('请长按二维码保存到相册');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pay-qr-page {
  min-height: 100vh;
  background: #f7f8fa;
}
.content {
  padding: 24px 20px;
  text-align: center;
}
.tip {
  font-size: 16px;
  font-weight: 600;
  color: #323233;
  margin-bottom: 8px;
}
.order-code {
  font-size: 12px;
  color: #969799;
  word-break: break-all;
  margin-bottom: 24px;
}
.qr-wrap {
  width: 240px;
  height: 240px;
  margin: 0 auto 12px;
  background: #fff;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}
.qr-img {
  width: 220px;
  height: 220px;
}
.qr-hint {
  font-size: 13px;
  color: #969799;
  margin-bottom: 28px;
}
.save-btn {
  margin-bottom: 8px;
}
</style>
